var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "log-view-container" }, [
    _c("div", { staticClass: "filter-wrapper" }, [
      _c(
        "div",
        { staticClass: "left" },
        [
          _c("el-switch", {
            staticStyle: { "margin-right": "10px" },
            attrs: { "inactive-text": _vm.$t("Auto-Scroll") },
            model: {
              value: _vm.isLogAutoScroll,
              callback: function($$v) {
                _vm.isLogAutoScroll = $$v
              },
              expression: "isLogAutoScroll"
            }
          }),
          _c("el-input", {
            staticStyle: { width: "240px", "margin-right": "10px" },
            attrs: {
              size: "small",
              "suffix-icon": "el-icon-search",
              placeholder: _vm.$t("Search Log"),
              clearable: ""
            },
            model: {
              value: _vm.logKeyword,
              callback: function($$v) {
                _vm.logKeyword = $$v
              },
              expression: "logKeyword"
            }
          }),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary", icon: "el-icon-search" },
              on: { click: _vm.onSearchLog }
            },
            [_vm._v(" " + _vm._s(_vm.$t("Search Log")) + " ")]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "right" },
        [
          _c("el-pagination", {
            attrs: {
              size: "small",
              total: _vm.taskLogTotal,
              "current-page": _vm.taskLogPage,
              "page-sizes": [1000, 2000, 5000, 10000],
              "page-size": _vm.taskLogPageSize,
              "page-count": 3,
              layout: "sizes, prev, pager, next"
            },
            on: {
              "update:currentPage": function($event) {
                _vm.taskLogPage = $event
              },
              "update:current-page": function($event) {
                _vm.taskLogPage = $event
              },
              "update:pageSize": function($event) {
                _vm.taskLogPageSize = $event
              },
              "update:page-size": function($event) {
                _vm.taskLogPageSize = $event
              }
            }
          }),
          _vm.errorLogData.length > 0
            ? _c(
                "el-badge",
                { attrs: { value: _vm.errorLogData.length } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        size: "small",
                        icon: "el-icon-warning-outline"
                      },
                      on: { click: _vm.toggleErrors }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("Error Count")) + " ")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ]),
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        {
          staticClass: "log-view-wrapper",
          class: _vm.isErrorsCollapsed ? "errors-collapsed" : "",
          attrs: { loading: _vm.isLogFetchLoading }
        },
        [
          _c("virtual-list", {
            ref: "log-view",
            staticClass: "log-view",
            attrs: {
              "data-key": "index",
              "data-sources": _vm.items,
              "data-component": _vm.itemComponent,
              keeps: _vm.taskLogPageSize,
              start: _vm.currentLogIndex - 1
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isErrorsCollapsed && !_vm.isErrorCollapsing,
              expression: "!isErrorsCollapsed && !isErrorCollapsing"
            }
          ],
          staticClass: "errors-wrapper",
          class: _vm.isErrorsCollapsed ? "collapsed" : ""
        },
        [
          _c(
            "ul",
            { staticClass: "error-list" },
            _vm._l(_vm.errorLogData, function(item) {
              return _c(
                "li",
                {
                  key: item.index,
                  staticClass: "error-item",
                  class: _vm.currentLogIndex === item.index ? "active" : "",
                  on: {
                    click: function($event) {
                      return _vm.onClickError(item)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "line-content" }, [
                    _vm._v(" " + _vm._s(item.msg) + " ")
                  ])
                ]
              )
            }),
            0
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }